<template>
  <div class="serveBrief">
    <section id="wrap">
      <div class="server-header">
        <img src="../../../assets/images/upload_file.png" alt="标题" />
      </div>
      <div class="server-content text-center">
        
        
        <ul class="tab-content-list">
          <transition name="ani" mode="out-in">
          <li>
           
           
            <div class="text-box">
               <ul class="badge-list">
				  
					   <li v-for="(item,index) in listData">
						   <a class="up-bnt" :href="$tool.src(item.file_url)" target="_blank">
							   <template v-if="lang=='zh'">
							   	{{item.file_desc}}
							   </template>
							   <template v-else>
							   	{{item.file_desc_en}}
							   </template>
						   </a>
					  
					   </li>
				  
               
                 
               
              </ul>
               
			</div>
          </li>

           
  

        </transition>

        </ul>
      </div>
    </section>
  </div>
</template>
    
<script>
import { getInspection } from "@/api/znOrder";
export default {
  name: "serveBrief",
  data() {
    return {
        listData:[],
		lang:localStorage.getItem('locale') || 'zh',
		param:{
			page:1,
			page_size:60
		 },
		 total_num:0
    };
  },
  computed: {
    
  },
  methods:{
     async getList(){
      const res = await this.$api["get"]("u_i/upload_list",this.param);
	  
      const {code,data} = res.data;
	  this.total_num=data.total_num;
	  this.listData=data.list;
       //console.log(data,"===data====data===");
      
    }
  },
  created(){
     this.getList()
  }
};
</script>
<style scoped lang="scss">
.ani-enter,.ani-leave-to{
   opacity: 0;
}
.ani-enter-to,.ani-leave{
  opacity: 1;
}
.ani-enter-active,.ani-leave-acitve{
  transition: all 1s;
}
#wrap {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 40px;
  .server-header {
    width: 100%;
    margin: 0px auto 0;
    & > img {
      display: block;
      width: 100%;
      margin: 0 auto;
      user-select: none;
    }
  }
  .server-content {
    .tab-header-list {
      display: inline-block;
      li {
        padding: 5px 16px;
        display: inline-block;
        cursor: pointer;
        &:not(:last-child) {
          margin-right: 30px;
        }
        &.active {
          border-radius: 4px;
          background-color: rgb(245, 104, 0);
          color: #fff;
        }
      }
    }
    .tab-content-list {
      margin-top: 35px;
      & > li {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      }
      .img-box {
        flex: 0 0 280px;
        border: 2px solid #888;
        box-sizing: border-box;
        padding: 15px;
        text-align: right;
        .download,
        .href {
          color: #3333cc;
          margin-right: 20px;
          font-size: 15px;
          line-height: 2;
        }
        & > img {
          display: block;
          max-width: 100%;
          margin:0 auto;
        }
      }
      .text-box {
        flex: 1;
        box-sizing: border-box;
        padding: 20px 40px;
        text-align: left;
        h4 {
          font-family: "Arial Negreta", "Arial Normal", "Arial";
          font-weight: 700;
          font-style: normal;
          font-size: 20px;
          vertical-align: middle;
          margin-bottom: 20px;
          .money {
            color: #d05800;
            font-weight: normal;
            margin-left: 30px;
          }
        }
        .brief {
          font-size: 16px;
          color: #666666;
          line-height: 28px;
        }
        h5 {
          font-family: "Arial Negreta", "Arial Normal", "Arial";
          font-weight: 700;
          font-style: normal;
          font-size: 16px;
          margin-top: 20px;
          margin-bottom: 20px;
        }
        .badge-list {
		  cursor:pointer;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          li {
            width: 33.333333%;
            padding-left: 30px;
            box-sizing: border-box;
            position: relative;
            font-size: 16px;
            color: #666666;
            line-height: 28px;
			.up-bnt{
				display:block;
				width:100%;
				&::before {
				  content: "";
				  display: block;
				  position: absolute;
				  left: 0;
				  top: 0;
				  width: 21px;
				  height: 100%;
				  background: url("../../../assets/images/down.png") no-repeat;
				  background-size: 21px 24px;
				  background-position: center center;
				}
			}
           
			
          }
        }
        .order-btn{
          display: block;
          margin: 88px auto 0;
        }
      }
    }
  }
}
</style>